module.exports = __webpack_public_path__ + "static/img/newul.924f7a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/newul.png
// module id = MJHU
// module chunks = 1